import React from 'react';
import PropTypes from 'prop-types';
import StartButtons from './StartButtons';
import {Typography} from '@customink/pigment-react';
import './Welcome_Lg.scss';
import {useAuth} from '~/auth/AuthContext';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
const Welcome_Lg = props => {
  const {
    onStart,
    onAddArt,
    onAddText,
    onChangeProductColor,
    onCheckout,
    onProduct,
    onRetrieveDesigns,
    onTextStart,
    onUpload,
    welcomeBack,
    isCurrentDesignInCart,
    isEditFromCart,
    isFundraisingMode,
    isMultiItemEligible,
    isStartFromDesignPage,
    cartItemCount,
    designName
  } = props;

  const customDimension = welcomeBack ? '?rs=wb' : '?rs=w';

  const teaser = () => {
    if (isFundraisingMode) {
      return (
        <Typography variant="heading3" className="ndx-Welcome_Lg-teaser">
          Create a Design for <br />
          Your Fundraiser!
        </Typography>
      );
    } else if (welcomeBack) {
      if (isStartingFromDesignInCart()) {
        return (
          <Typography variant="heading3" className="ndx-Welcome_Lg-teaser">
            {isMultiItemEligible && isEditFromCart
              ? 'Edit design:'
              : 'Start from'}{' '}
            <strong>{designName}</strong>
          </Typography>
        );
      } else {
        return (
          <Typography variant="heading3" className="ndx-Welcome_Lg-teaser">
            What's next for you?
          </Typography>
        );
      }
    } else {
      return (
        <Typography variant="heading3" className="ndx-Welcome_Lg-teaser">
          How do you want to start?
        </Typography>
      );
    }
  };

  const multiItemSubHeader = () => {
    if (isMultiItemEligible && isEditFromCart) {
      return multiItemEditFromCartSubHeader();
    } else {
      return (
        <Typography
          component="p"
          variant="paragraphSmall"
          className="ndx-Welcome_Lg-multiItem-subHeader">
          Go ahead and start designing your next product. Once you've finished
          designing, simply add it to your cart.
        </Typography>
      );
    }
  };

  const multiItemEditFromCartSubHeader = () => {
    return (
      <Typography
        component="p"
        variant="paragraphSmall"
        className="ndx-Welcome_Lg-multiItem-subHeader">
        Go ahead and update your design just how you like it. Once you've
        finished designing, simply click <strong>Save & Update Cart.</strong>
      </Typography>
    );
  };

  const isStartingFromDesignInCart = () => {
    return isStartFromDesignPage && designName && isCurrentDesignInCart;
  };

  const auth = useAuth();

  return (
    <div className="ndx-Welcome_Lg" onClick={onStart}>
      <div className="ndx-Welcome_Lg-hello">
        <div>
          {teaser()}
          {isStartingFromDesignInCart() ? multiItemSubHeader() : ''}
          <StartButtons
            cartItemCount={cartItemCount}
            customDimension={customDimension}
            isMultiItemEligible={isMultiItemEligible}
            onAddArt={onAddArt}
            onAddText={onAddText}
            onChangeProductColor={onChangeProductColor}
            onCheckout={onCheckout}
            onProduct={onProduct}
            onRetrieveDesigns={onRetrieveDesigns}
            onTextStart={onTextStart}
            onUpload={onUpload}
          />
        </div>
        {auth.user?.isInternal && (
          <Typography fontSize={'small'} sx={{mb: 4, mx: 'auto'}}>
            Logged in as Inker: {auth.user.email}
          </Typography>
        )}
      </div>
    </div>
  );
};

Welcome_Lg.displayName = 'Welcome_Lg';

const propTypes = {
  cartItemCount: PropTypes.number,
  designName: PropTypes.string,
  isCurrentDesignInCart: PropTypes.bool,
  isEditFromCart: PropTypes.bool,
  isFundraisingMode: PropTypes.bool,
  isMultiItemEligible: PropTypes.bool,
  isStartFromDesignPage: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.object
  ]),
  welcomeBack: PropTypes.bool,
  onAddArt: PropTypes.func,
  onAddText: PropTypes.func,
  onChangeProductColor: PropTypes.func,
  onCheckout: PropTypes.func,
  onNew: PropTypes.func,
  onProduct: PropTypes.func,
  onRetrieveDesigns: PropTypes.func,
  onStart: PropTypes.func,
  onTextStart: PropTypes.func,
  onUpload: PropTypes.func
};

Welcome_Lg.propTypes = propTypes;

export default Welcome_Lg;
